import { CompleteProfileService } from './complete-profile.service';

import './complete-profile.less';

export class CompleteProfileController {
    private email: string;
    private confirmEmail: string;

    static $inject = ["completeProfileService"];
    constructor(private completeProfileService: CompleteProfileService) {
    }

    private submit() {
        return this.completeProfileService.setEmail(this.email, this.confirmEmail);
    }
}


// WEBPACK FOOTER //
// ./app/complete-profile/complete-profile.controller.ts